<template>
<jobs />
</template>

<script>
import Profile from '@/pages/profile'
import Jobs from '@/pages/jobs-list'

export default {
  components: { Profile, Jobs },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main.vue